import UpdateBasicSettings from './UpdateBasicSettings';
import { useDispatch, useSelector } from 'react-redux';
import UpdateAddressSettings from './UpdateAddressSetting';
import ChangePassword from './PasswordSettings';
import pmsConstants from '../../pmsConstants';
import StaffBasicUserSettings from './StaffBasicUserSettings';
import PatientBasicUserSettings from './PatientBasicUserSettings';
import DeletePatient from './DeletePatient';
import { useState } from 'react';

function SettingsTabs() {
  const dispatch = useDispatch();
  const loginDetails = useSelector(state => state.loginDetails);
  const [activeTab, setActiveTab] = useState('basic');
  
  var loggedInUser = null;
  var userType = '';
  if (loginDetails != null) {
    loggedInUser = loginDetails.loggedInUser;
    if (loggedInUser != null) {
      userType = loggedInUser.user_type;
    }
  }

  const changeTab = (key) => {
    setActiveTab(key);
    dispatch({
      type: 'clearMsg'
    })
    dispatch({
      type: 'resetSettings'
    })
  }

  const getTabClass = (tabKey) => {
    return `w-full px-6 py-3  text-sm transition-all duration-200 ${
      activeTab === tabKey 
        ? 'font-bold text-gray-700 bg-white shadow-lg transform -translate-y-1 rounded-t-lg' 
        : 'font-medium text-white bg-gradient-to-r from-[#0B6D76] to-[#09757F] hover:from-[#095C64] hover:to-[#0A6B73] rounded-t-lg'
    }`;
  }

  const getTabContainerClass = (index, isLast) => {
    return `relative ${index === 0 ? 'rounded-tl-lg' : ''} ${isLast ? 'rounded-tr-lg' : ''} ${index < 3 ? 'border-b border-gray-200' : ''}`;
  }

  return (
    <div className="w-full">
      {/* Tab Navigation */}
      <div className="flex gap-x-2 bg-[#edeef2]">
        <div className={getTabContainerClass(0, false)}>
          <button
            onClick={() => changeTab('basic')}
            className={getTabClass('basic')}
          >
            Basic Details
          </button>
        </div>
        
        {userType === pmsConstants.USER_TYPE_PRACTICE_STRING && (
          <div className={getTabContainerClass(1, false)}>
            <button
              onClick={() => changeTab('address')}
              className={getTabClass('address')}
            >
              Address
            </button>
          </div>
        )}
        
        <div className={getTabContainerClass(userType === pmsConstants.USER_TYPE_PRACTICE_STRING ? 2 : 1, userType === pmsConstants.USER_TYPE_PATIENT ? false : true)}>
          <button
            onClick={() => changeTab('change_password')}
            className={getTabClass('change_password')}
          >
            Change Password
          </button>
        </div>
        
        {userType === pmsConstants.USER_TYPE_PATIENT && (
          <div className={getTabContainerClass(3, true)}>
            <button
              onClick={() => changeTab('delete_patient')}
              className={getTabClass('delete_patient')}
            >
              Delete Patient
            </button>
          </div>
        )}
        
        {/* Empty space after tabs without styling */}
        {/* <div className="flex-1 border-b border-gray-200 bg-gray-50"></div> */}
      </div>

      {/* Tab Content */}
      <div className="p-4 rounded-xl">
        {activeTab === 'basic' && (
          <div>
            {userType === pmsConstants.USER_TYPE_PRACTICE_STRING && <UpdateBasicSettings />}
            {userType === pmsConstants.USER_TYPE_STAFF && <StaffBasicUserSettings />}
            {userType === pmsConstants.USER_TYPE_PATIENT && <PatientBasicUserSettings />}
          </div>
        )}
        
        {activeTab === 'address' && userType === pmsConstants.USER_TYPE_PRACTICE_STRING && (
          <UpdateAddressSettings />
        )}
        
        {activeTab === 'change_password' && (
          <ChangePassword />
        )}
        
        {activeTab === 'delete_patient' && userType === pmsConstants.USER_TYPE_PATIENT && (
          <DeletePatient />
        )}
      </div>
    </div>
  );
}

export default SettingsTabs;
